import React, { useCallback, useRef } from 'react';
import classnames from 'classnames';
import ArrowDownIcon from '../../Icons/ArrowDown';
import { IconSize } from '../../Icons/IconWrap';
import Sticky from '../../Sticky';
import { scrollIntoViewWithHeader } from '../../utils/scrollIntoViewWithHeader';
import FolderDropdownDesktopMenu from '../FolderDropdownDesktop/FolderDropdownDesktopMenu';
import LoadingIndicator from '../../LoadingIndicator';
import cssVars from '../../styles/variables.scss';
import folderDropdownMobileStyles from './FolderDropdownMobile.scss';
var FolderDropdownContent = function (_a) {
    var id = _a.id, isOpen = _a.isOpen, _b = _a.offsetTop, offsetTop = _b === void 0 ? 0 : _b, openDropdown = _a.openDropdown, closeDropdown = _a.closeDropdown, folders = _a.folders, filterEmpty = _a.filterEmpty, disabled = _a.disabled, currentFolder = _a.currentFolder, setSelectedFolderId = _a.setSelectedFolderId, _c = _a.arrowIconSize, arrowIconSize = _c === void 0 ? IconSize.SMALL : _c, isLoading = _a.isLoading, hasMore = _a.hasMore, fetchMore = _a.fetchMore;
    var rootRef = useRef(null);
    var headerHeight = parseInt(cssVars['site-header-height-mobile']);
    var selectFolder = useCallback(function (folderId) {
        setSelectedFolderId(folderId);
        closeDropdown();
        if (rootRef.current) {
            scrollIntoViewWithHeader(rootRef.current, true, offsetTop);
        }
    }, [closeDropdown, setSelectedFolderId, offsetTop]);
    var toggleDropdown = useCallback(function () {
        // If opening a menu, scroll to root element
        if (!isOpen) {
            openDropdown();
            if (rootRef.current) {
                scrollIntoViewWithHeader(rootRef.current, true, offsetTop);
            }
        }
        else {
            closeDropdown();
        }
    }, [isOpen, openDropdown, closeDropdown, offsetTop]);
    return (React.createElement("div", { className: classnames(folderDropdownMobileStyles['root'], disabled && folderDropdownMobileStyles['disabled']), ref: rootRef },
        React.createElement(Sticky, { className: 'sticky', marginTop: offsetTop + headerHeight }, function (isStuck) { return (React.createElement("div", { className: classnames(folderDropdownMobileStyles['toggle'], isStuck && folderDropdownMobileStyles['stuck']), "aria-hidden": "true", onClick: toggleDropdown },
            React.createElement("div", { className: folderDropdownMobileStyles['title'] }, currentFolder && currentFolder.name),
            React.createElement(ArrowDownIcon, { className: classnames(folderDropdownMobileStyles['icon-arrow'], isOpen && folderDropdownMobileStyles['is-open']), size: arrowIconSize }))); }),
        isOpen && (React.createElement("div", { className: folderDropdownMobileStyles['content'] },
            React.createElement(FolderDropdownDesktopMenu, { id: id, folders: folders, filterEmpty: filterEmpty, setSelectedFolderId: selectFolder, currentFolder: currentFolder, hasMore: hasMore, fetchMore: fetchMore }),
            isLoading && React.createElement(LoadingIndicator, { coverMode: true, view: "llama" })))));
};
FolderDropdownContent.displayName = 'FolderDropdownContent';
export default FolderDropdownContent;
//# sourceMappingURL=FolderDropdownContent.js.map